import { render, staticRenderFns } from "./scrollArea.vue?vue&type=template&id=2e7c53ff&scoped=true"
import script from "./scrollArea.vue?vue&type=script&lang=js"
export * from "./scrollArea.vue?vue&type=script&lang=js"
import style0 from "./scrollArea.vue?vue&type=style&index=0&id=2e7c53ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7c53ff",
  null
  
)

export default component.exports